import { Dispatch, MouseEventHandler, SetStateAction, useEffect, useRef, useState } from 'react'
import './user-menu-item-default.component.scoped.scss'
import { NavLink, useLocation } from 'react-router-dom'
import { Selector, ToggleTheme } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import { useSqScopedCssHash } from '@squidit/react-css'

interface Props {
  title: string
  iconClasses?: string
  link?: string
  onClick?: MouseEventHandler<HTMLButtonElement>
  setOpen: (openUserMenu: boolean) => void
}

export const UserMenuItem = ({ title, link, iconClasses, onClick, setOpen }: Props) => {
  const [active, setActive] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const { t } = useTranslation('defaultLayout')
  const wrapperRef = useRef<any>(null)
  const hash = useSqScopedCssHash(wrapperRef)

  const location = useLocation()

  useEffect(() => {
    const currentUrl = location.pathname

    if (link?.startsWith('/profile/progressive')) {
      setActive(currentUrl.startsWith('/profile/progressive'))
      return
    }

    setActive(currentUrl === link)
  }, [location])

  const handleMouseEnter = () => {
    setIsHovered(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
  }

  if (onClick) {
    return (
      <button
        onClick={(event) => {
          onClick(event)
        }}
        className={`user-menu-item ${active ? 'active' : ''} ${isHovered ? 'hover' : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        ref={wrapperRef}
      >
        <i className={`${iconClasses} ${active || isHovered ? 'active fa-solid' : 'fa-regular'}`}></i>
        <span className={`${active ? 'active' : ''}`}>{title}</span>
        {title === t('userMenu.darkMode') && <ToggleTheme labelPosition="none" className="dark-mode" externalCssScopedHash={hash} />}
      </button>
    )
  }

  return (
    <NavLink
      to={link ?? ''}
      onClick={() => {
        setOpen(false)
      }}
      className={({ isActive }) => {
        return `user-menu-item ${active ? 'active' : ''} ${isHovered ? 'hover' : ''} ${link === '#logout' ? 'danger' : ''}`
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={wrapperRef}
    >
      <i className={`${iconClasses} ${active || isHovered ? 'active fa-solid' : 'fa-regular'}`}></i>
      <span className={`${active ? 'active' : ''}`}>{title}</span>
    </NavLink>
  )
}
